<ng-container>
    <mat-selection-list matSelectionList
                        hideSingleSelectionIndicator
                        [multiple]="false"
                        class="st-external-actions-overlay"
                        (selectionChange)="actionChanged($event)">
        <ng-container *ngFor="let action of actions; index as i">
            <ng-template [ngIf]="i==0 && !inFullScreen">
                <mat-list-option matListItem
                                 [dir]="isRTL"
                                 (click)="onObjectOpen.emit()">
                    <mat-icon matListItemIcon
                              class="st-external-actions-overlay-icon">fullscreen</mat-icon>
                    <div matListItemTitle>
                        {{openFullScreenActionButtonLabel}}</div>
                </mat-list-option>
            </ng-template>
            <ng-template [ngIf]="data?.visibilityCriteria[action?.ID] && editable">
                <mat-list-option [value]="action.ID"
                                 [dir]="isRTL">
                    <mat-icon matListItemIcon
                              *ngIf="(action.ID !== currentAction)  &&  ( !currentActionCompleted || !currentActionError)"
                              fontSet="material-symbols-outlined"
                              class="st-external-actions-overlay-icon"
                              [style.background-image]="'url(' +  action?.Icon + ')'"
                              [class.st-external-actions-overlay-icon-delete]="action.ID == 'DELETE'">
                        {{ getIcon(action) }}
                    </mat-icon>
                    <mat-icon matListItemIcon
                              class="st-external-actions-overlay-icon-error"
                              *ngIf="currentActionError && action.ID === currentAction">error</mat-icon>
                    <mat-icon matListItemIcon
                              *ngIf="currentActionCompleted && action.ID === currentAction">check_circle</mat-icon>
                    <loader [diameter]="25"
                            matListItemIcon
                            *ngIf="(action.ID === currentAction ) && (!currentActionError && !currentActionCompleted)"
                            class="st-external-actions-overlay-loader"
                            [strokeWidth]="4"></loader>
                    <div matListItemTitle
                         [class.st-external-actions-overlay-delete]="action.ID == 'DELETE'">
                        {{ getExternaActionsLabel(action) }}
                    </div>
                </mat-list-option>
            </ng-template>
        </ng-container>
    </mat-selection-list>
</ng-container>
